import { useQuery } from "react-query";
import { useGlobalStore } from "@/store/GlobalStore";
import { useEffect, useLayoutEffect } from "react";
import { UserInfo } from "@/utils/userinfo/types";
import queryString from "query-string";
import { goToMainRoute, host, isTestOrProduct } from "project-config/utils/env";
import { STORAGE } from "project-config/constants";
import { CookieHelper } from "project-config/utils/cookie-helper";
import { Cookie } from "project-config/utils";
import { LanguageFlag } from "@/constant/LanguageFlag";
import routerUtil from "@/utils/routerUtil";
import { useUserPropertyStore } from "@/store2/userProperty/user-property-store";
import request from "project-config/services/request/request";
import { saleSmartlyInstance } from "project-config/services";

const fetchUserData = async ({ queryKey }: { queryKey: any[] }) => {
  const [url, , config] = queryKey;
  const response = await request.post(url, {}, config);
  return response;
};

export default function useGlobalAuth() {
  const {
    setUserInfo,
    setLanguageFlag,
    setIsZh,
    userInfo,
    fetchUserDesktopInfo,
    fetchUserIsCustomized,
  } = useGlobalStore();
  const { fetchUserProperty } = useUserPropertyStore();
  const searchParams = queryString.parse(window.location.search);
  const token = searchParams.rayvision_token as string;
  const platform =
    (searchParams.platform as string) || localStorage.getItem(STORAGE.PLATFORM);
  const lang = searchParams.lang as string;
  const queryKey = token
    ? [
        "/api/rendering/user/queryUser",
        {},
        { headers: { userKey: token, platform } },
      ]
    : ["/api/rendering/user/queryUser"];

  const { data } = useQuery<any, Error, RequestResponse<UserInfo>, any[]>(
    queryKey,
    fetchUserData
  );

  useEffect(() => {
    const isAuthLogin = Cookie.getCookie("rayvision_isAuthLogin");
    if (isAuthLogin) {
      window.location.href = host;
      return;
    }

    if (!token) return;

    delete searchParams.rayvision_token;
    delete searchParams.platform;
    if (lang) {
      if (
        lang === "zh_CN" &&
        CookieHelper.getLocal(STORAGE.LANGUAGE_FLAG) === `${LanguageFlag.EN}`
      ) {
        CookieHelper.set(STORAGE.LANGUAGE_FLAG, `${LanguageFlag.ZH}`);
        CookieHelper.setCookie(STORAGE.LANGUAGE_FLAG, `${LanguageFlag.ZH}`);
        CookieHelper.set(STORAGE.LANGUAGE_FLAG, `${LanguageFlag.ZH}`, true);
        CookieHelper.setCookie(
          STORAGE.LANGUAGE_FLAG,
          `${LanguageFlag.ZH}`,
          365,
          true
        );
        setLanguageFlag(LanguageFlag.ZH);
        setIsZh(true);
      } else if (lang !== "zh_CN") {
        CookieHelper.setCookie(
          STORAGE.LANGUAGE_FLAG,
          `${LanguageFlag.EN}`,
          365,
          true
        );
        CookieHelper.setCookie(STORAGE.LANGUAGE_FLAG, `${LanguageFlag.EN}`);
        CookieHelper.set(STORAGE.LANGUAGE_FLAG, `${LanguageFlag.EN}`, true);
        CookieHelper.set(STORAGE.LANGUAGE_FLAG, `${LanguageFlag.EN}`);
        setLanguageFlag(LanguageFlag.EN);
        setIsZh(false);
      }
    }
    const search = queryString.stringify(searchParams, {
      skipNull: true,
    });
    const basename =
      process.env.NODE_ENV === "development" ? "/" : "/center/user";
    const currentPath = window.location.pathname.replace(basename, "");
    routerUtil.navigate?.(`${currentPath}?${search}`);
  }, [searchParams, token, lang, setLanguageFlag, setIsZh]);
  useEffect(() => {
    fetchUserProperty();
    fetchUserDesktopInfo();
    fetchUserIsCustomized();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    // 主账号修改子账号密码后接口返回的 code
    if (data?.code === 840) {
      return;
    }

    if (!data?.data) {
      isTestOrProduct() && goToMainRoute();
      return;
    }

    localStorage.setItem(
      "platform",
      data.data.platform?.toString() || platform || ""
    );

    // userInfo接口成功后，删除sessionStorage中的userKey
    sessionStorage.removeItem(STORAGE.USER_KEY);

    setUserInfo(data.data);
  }, [data?.data, setUserInfo, platform, token, data?.code]);

  useEffect(() => {
    if (!userInfo) return;
    const { raySyncUserKey, userName, email, phone } = userInfo;
    saleSmartlyInstance.setUserInfo({
      user_id: raySyncUserKey,
      user_name: userName,
      email,
      phone,
    });
  }, [userInfo]);
}
